<template>
  <div>
    <div class="d-flex">
    <div class="authCard m-auto">
      <h3>Account Setup</h3>
      <p class="secondary-text semi-bold">Please help answer the questions below to help us
        recommend the best investment plans for you</p>

      <form class="auth-form" @submit="updateUser">
        <div class="form-group">
          <label>How much do you earn monthly?</label>
          <select v-model="salary" class="form-control">
            <option value=""></option>
            <option value="level1">50,000 - 100,000</option>
            <option value="level2">101,000 - 200,000</option>
          </select>
        </div>

        <div class="form-group">
          <label>What is Your Risk Appetite?</label>
          <select v-model="risk_appetite" class="form-control">
            <option value=""></option>
            <option value="level1">50,000 - 100,000</option>
            <option value="level1">101,000 - 200,000</option>
          </select>
        </div>

        <div class="form-group">
          <label>What is your preferred communication channel?</label>
          <select v-model="comm_channel" class="form-control">
            <option value=""></option>
            <option value="whatsapp">Whatsapp</option>
            <option value="email">Email</option>
            <option value="sms">SMS</option>
          </select>
        </div>
        <div>
          <button class="btn primary-btn btn-block">SETUP ACCOUNT</button>
        </div>
      </form>
    </div>
    </div>
    <splash v-if="showSplash"></splash>
  </div>
</template>

<script>
import Splash from '../components/Splash.vue';

export default {
  components: {
    Splash,
  },
  data() {
    return {
      salary: '',
      risk_appetite: '',
      comm_channel: '',
      showSplash: false,
    };
  },
  methods: {
    updateUser(e) {
      e.preventDefault();
      const data = {
        salary: this.salary,
        riskAppetite: this.risk_appetite,
        preferredChannel: this.comm_channel,
      };
      const url = `${this.$baseUrl}/profile/update`;
      this.$http({
        url,
        data,
        method: 'POST',
      }).then(() => {
        this.showSplash = true;
      }).catch((err) => {
        console.log(err);
      });
    },
  },
};
</script>

<style scoped>
  .d-flex{
    margin-top: 4rem;
    position: relative;
  }
  .secondary-text {
    color: #6B6B6B;
    width: 90%;
    margin: auto;
  }
  .auth-form{
    text-align: left;
    margin-top: 4rem;
  }
</style>
